//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:{
        title:{
            type:String,
            default:''
        },
        step:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            ownerView:true
        }
    },
    methods: {
        tap(){
            this.$emit('click')
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/easyQuery/components/top.vue